import * as React from 'react';

import * as styles from './styles.css';

export interface IWrapContainerProps {
  children: React.ReactNode;
}

export const WrapContainer: React.FC<IWrapContainerProps> = ({ children }) => {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['container']}>{children}</div>
    </div>
  );
};
